import React, { useState, useEffect } from 'react';
import Assessment from './Assessment';
import Results from './Results';
import Analytics from './Analytics';
import JobBoard from './JobBoard';
import AdminDashboard from './AdminDashboard';
import { storage } from '../utils/storage';

function Dashboard({ currentUser, setCurrentUser }) {
  const [currentView, setCurrentView] = useState('dashboard');
  const [currentAssessment, setCurrentAssessment] = useState(null);
  const [assessmentResults, setAssessmentResults] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    loadHistory();
  }, [currentUser]);

  const loadHistory = async () => {
    const user = await storage.getUser(currentUser);
    const userAssessments = user?.assessments || [];
    setHistory(userAssessments.sort((a, b) => new Date(b.timestamp || b.date) - new Date(a.timestamp || a.date)));
  };

  const logout = async () => {
    await storage.removeCurrentUser();
    setCurrentUser(null);
  };

  const startAssessment = (type) => {
    setCurrentAssessment(type);
    setCurrentView('assessment');
  };

  const onAssessmentComplete = (results) => {
    setAssessmentResults(results);
    setCurrentView('results');
    loadHistory();
  };

  const resetToHome = () => {
    setCurrentView('dashboard');
    setCurrentAssessment(null);
    setAssessmentResults(null);
  };

  if (currentView === 'assessment') {
    return <Assessment type={currentAssessment} currentUser={currentUser} onComplete={onAssessmentComplete} />;
  }

  if (currentView === 'results') {
    return <Results results={assessmentResults} onReset={resetToHome} />;
  }

  if (currentView === 'analytics') {
    return <Analytics currentUser={currentUser} onClose={() => setCurrentView('dashboard')} />;
  }

  if (currentView === 'jobboard') {
    return <JobBoard onClose={() => setCurrentView('dashboard')} />;
  }

  if (currentView === 'admin') {
    return <AdminDashboard onClose={() => setCurrentView('dashboard')} />;
  }

  return (
    <div>
      <header>
        <h1>Career Assessment Tools</h1>
        <p>Discover your ideal career path</p>
        <div id="user-info">
          <span>Welcome, {currentUser}</span>
          {currentUser === 'admin@admin.com' && (
            <button onClick={() => setCurrentView('admin')} style={{ marginRight: '10px' }}>Admin Panel</button>
          )}
          <button onClick={logout}>Logout</button>
        </div>
      </header>

      <main>
        <section className="assessment-grid">
          <div className="assessment-card" onClick={() => startAssessment('personality')}>
            <h3>Personality Assessment</h3>
            <p>Discover your work style and preferences</p>
            <button>Start Assessment</button>
          </div>
          
          <div className="assessment-card" onClick={() => startAssessment('skills')}>
            <h3>Skills Assessment</h3>
            <p>Evaluate your technical and soft skills</p>
            <button>Start Assessment</button>
          </div>
          
          <div className="assessment-card" onClick={() => startAssessment('interests')}>
            <h3>Career Interests</h3>
            <p>Find careers that match your interests</p>
            <button>Start Assessment</button>
          </div>
          
          <div className="assessment-card" onClick={() => startAssessment('tech')}>
            <h3>Tech Industry</h3>
            <p>Technology and software development focus</p>
            <button>Start Assessment</button>
          </div>
          
          <div className="assessment-card" onClick={() => startAssessment('healthcare')}>
            <h3>Healthcare</h3>
            <p>Medical and healthcare industry assessment</p>
            <button>Start Assessment</button>
          </div>
          
          <div className="assessment-card" onClick={() => startAssessment('finance')}>
            <h3>Finance</h3>
            <p>Financial services and banking sector</p>
            <button>Start Assessment</button>
          </div>
        </section>
        
        <div className="assessment-grid">
          <div className="assessment-card" onClick={() => setCurrentView('analytics')}>
            <h3>Progress Analytics</h3>
            <p>Visual charts of your assessment progress</p>
            <button>View Analytics</button>
          </div>
          
          <div className="assessment-card" onClick={() => setCurrentView('jobboard')}>
            <h3>Job Opportunities</h3>
            <p>Browse jobs from LinkedIn and Indeed</p>
            <button>Browse Jobs</button>
          </div>
        </div>
        
        <section id="dashboard-history">
          <h2>Your Activity History</h2>
          <div>
            {history.length === 0 ? (
              <p>No activity yet. Take your first assessment to get started!</p>
            ) : (
              history.map((assessment, index) => (
                <div key={index} className="activity-item">
                  <div className="activity-details">
                    <div className="activity-type">
                      {assessment.type.charAt(0).toUpperCase() + assessment.type.slice(1)} Assessment Completed
                    </div>
                    <div className="activity-summary">
                      Completed {assessment.answers?.length || 0} questions
                    </div>
                  </div>
                  <div className="activity-date">
                    {new Date(assessment.date).toLocaleDateString()}
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Dashboard;